import { CAT_ACTION_TYPE, CatActions } from './cat-type';
import { RootState } from '../../../../redux/root-reducer';
import { MenuInCatType } from '../../../../shared/models/food-menu';

export enum CAT_STATE_KEY {
  LIST = 'list',
  LIST_META_DATA = 'meta_data',
  FULL_LIST = 'full_list',
  CAT_COUNT = 'category_count',
  DETAIL = 'detail',
  ALERT_SUCCESS = 'alert_success',
  ALERT_FAILURE = 'alert_failure',
  ALERT_SORT_SUCCESS = 'alert_sorted_success',
  ORIGINAL_MENU_IN_CAT = 'original_menu_in_cat',
}

export type AlertData = {
  isVisible: boolean,
  translationValues: {
    categoryName: string,
  },
};

export type CatState = {
  [CAT_STATE_KEY.LIST]?: object,
  [CAT_STATE_KEY.LIST_META_DATA]?: object,
  [CAT_STATE_KEY.FULL_LIST]?: object,
  [CAT_STATE_KEY.CAT_COUNT]?: number,
  [CAT_STATE_KEY.ALERT_SUCCESS]?: AlertData,
  [CAT_STATE_KEY.ALERT_FAILURE]?: AlertData,
  [CAT_STATE_KEY.ALERT_SORT_SUCCESS]?: {isVisible: boolean},
  [CAT_STATE_KEY.DETAIL]?: MenuInCatType,
  [CAT_STATE_KEY.ORIGINAL_MENU_IN_CAT]?: MenuInCatType,
};

const initialState: CatState = {
  [CAT_STATE_KEY.LIST]: [],
  [CAT_STATE_KEY.LIST_META_DATA]: undefined,
  [CAT_STATE_KEY.FULL_LIST]: undefined,
  [CAT_STATE_KEY.ALERT_SUCCESS]: {
    isVisible: false,
    translationValues: {
      categoryName: '???',
    },
  },
  [CAT_STATE_KEY.ALERT_FAILURE]: {
    isVisible: false,
    translationValues: {
      categoryName: '???',
    },
  },
  [CAT_STATE_KEY.ALERT_SORT_SUCCESS]: {
    isVisible: false,
  },
};

export const catReducers = (state = initialState, action: CatActions) => {
  switch (action.type) { // NOSONAR [typescript:S1301] followed usage pattern of reducer
    case CAT_ACTION_TYPE.SET_CAT_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value
      };
    default:
      return state;
  }
};

export const catStateSelector = (key: CAT_STATE_KEY) => (state: RootState) => state.cat[key];
